import * as React from "react"
import Svg, {Path} from "react-native-svg"

// <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
//      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
//      class="icon icon-tabler icons-tabler-outline icon-tabler-adjustments-horizontal">
//     <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
//     <path d="M12 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>
//     <path d="M4 6l8 0"/>
//     <path d="M16 6l4 0"/>
//     <path d="M6 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>
//     <path d="M4 12l2 0"/>
//     <path d="M10 12l10 0"/>
//     <path d="M15 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>
//     <path d="M4 18l11 0"/>
//     <path d="M19 18l1 0"/>
// </svg>

function AdjustmentsHorizontalSvg(props) {
    return (
        <Svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <Path stroke={"none"} d={"M0 0h24v24H0z"} fill={"none"} />
            <Path d={"M12 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"} />
            <Path d={"M4 6l8 0"} />
            <Path d={"M16 6l4 0"} />
            <Path d={"M6 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"} />
            <Path d={"M4 12l2 0"} />
            <Path d={"M10 12l10 0"} />
            <Path d={"M15 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"} />
            <Path d={"M4 18l11 0"} />
            <Path d={"M19 18l1 0"} />
        </Svg>
    )
}

export default AdjustmentsHorizontalSvg
